import { render, staticRenderFns } from "./EditorEditProjectItem.vue?vue&type=template&id=30a1d51b&scoped=true&"
import script from "./EditorEditProjectItem.vue?vue&type=script&lang=js&"
export * from "./EditorEditProjectItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a1d51b",
  null
  
)

export default component.exports